/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import { createAction, createReducer } from 'utils/reducer';

const PATH = 'processTypes/';
const DISABLE_ERRORS = `${PATH}DISABLE_ERRORS`;
const TOGGLE_FORM = `${PATH}TOGGLE_FORM`;
const CHANGE_CONTROLS = `${PATH}CHANGE_CONTROLS`;
const TOGGLE_DELETE = `${PATH}TOGGLE_DELETE`;
const TOGGLE_EDIT_PROCESS_TYPE = `${PATH}TOGGLE_EDIT_PROCESS_TYPE`;
const SET_INVALID_CONTROLS = `${PATH}SET_INVALID_CONTROLS`;

export const PROCESS_TYPES = {
  CREATE_PROCESS_TYPE: `${PATH}CREATE_PROCESS_TYPE`,
  CREATE_PROCESS_TYPE_SUCCESS: `${PATH}CREATE_PROCESS_TYPE_SUCCESS`,
  GET_STATE_FROM_API: `${PATH}GET_STATE_FROM_API`,
  GET_STATE_FROM_API_SUCCESS: `${PATH}GET_STATE_FROM_API_SUCCESS`,
  DELETE_PROCESS_TYPE: `${PATH}DELETE_PROCESS_TYPE`,
  DELETE_PROCESS_TYPE_SUCCESS: `${PATH}DELETE_PROCESS_TYPE_SUCCESS`,
  DELETE_PROCESS_TYPE_FAIL: `${PATH}DELETE_PROCESS_TYPE_FAIL`,
  EDIT_PROCESS_TYPE_SUCCESS: `${PATH}EDIT_PROCESS_TYPE_SUCCESS`,
  EDIT_PROCESS_TYPE: `${PATH}EDIT_PROCESS_TYPE`,
  EXPORT_PROCESS_TYPE: `${PATH}EXPORT_PROCESS_TYPE`,
  EXPORT_PROCESS_TYPE_SUCCESS: `${PATH}EXPORT_PROCESS_TYPE_SUCCESS`,
  UPDATE_LOSS_PERCENTAGE: `${PATH}UPDATE_LOSS_PERCENTAGE`,
  UPDATE_LOSS_PERCENTAGE_SUCCESS: `${PATH}UPDATE_LOSS_PERCENTAGE_SUCCESS`,
  UPDATE_LOSS_PERCENTAGE_FAIL: `${PATH}UPDATE_LOSS_PERCENTAGE_FAIL`,
  GET_OPERATIONAL_MASTERS: 'GET_OPERATIONAL_MASTERS',
  GET_OPERATIONAL_MASTERS_SUCCESS: 'GET_OPERATIONAL_MASTERS_SUCCESS',
  GET_PROCESS_TYPES_SUCCESS: `${PATH}GET_PROCESS_TYPES_SUCCESS`,
  CREATE_RECEIPT_TRIGGER: `${PATH}CREATE_RECEIPT_TRIGGER`,
  CREATE_RECEIPT_TRIGGER_SUCCESS: `${PATH}CREATE_RECEIPT_TRIGGER_SUCCESS`,
  CREATE_DISPATCH_TRIGGER: `${PATH}CREATE_DISPATCH_TRIGGER`,
  CREATE_DISPATCH_TRIGGER_SUCCESS: `${PATH}CREATE_DISPATCH_TRIGGER_SUCCESS`,
};

export const processTypesActions = {
  disableErrors: createAction(DISABLE_ERRORS),
  toggleForm: createAction(TOGGLE_FORM, 'modal'),
  changeControls: createAction(CHANGE_CONTROLS, 'controls', 'invalidControls'),
  toggleDelete: createAction(TOGGLE_DELETE, 'id'),
  toggleEdit: createAction(TOGGLE_EDIT_PROCESS_TYPE, 'item'),
  setInvalidControls: createAction(SET_INVALID_CONTROLS, 'controls'),
  getStateFromApi: createAction(PROCESS_TYPES.GET_STATE_FROM_API),
  createProcessType: createAction(PROCESS_TYPES.CREATE_PROCESS_TYPE, 'controls'),
  editProcessType: createAction(PROCESS_TYPES.EDIT_PROCESS_TYPE, 'id', 'controls'),
  deleteProcessType: createAction(PROCESS_TYPES.DELETE_PROCESS_TYPE, 'id'),

  exportProcessTypes: createAction(PROCESS_TYPES.EXPORT_PROCESS_TYPE),
  updateLossPercentage: createAction(
    PROCESS_TYPES.UPDATE_LOSS_PERCENTAGE,
    'percentage',
    'processTypeIds',
  ),
  getOperationalMasters: createAction(PROCESS_TYPES.GET_OPERATIONAL_MASTERS),
  getProcessTypes: createAction(PROCESS_TYPES.GET_PROCESS_TYPES),
  createReceiptTrigger: createAction(PROCESS_TYPES.CREATE_RECEIPT_TRIGGER, 'controls'),
  createDispatchTrigger: createAction(PROCESS_TYPES.CREATE_DISPATCH_TRIGGER, 'controls'),
};

const defaultInvalidInputs = {
  name: false,
};

const defaultControls = {
  name: '',
  allowMultipleLots: false,
  allowMultipleFruits: false,
  loss: 0,
  productId: null,
  autoCreateInboundPak: false,
  allowPakSubdivision: false,
  nextProcessTypeId: null,
  lowTimeThreshold: null,
  highTimeThreshold: null,
  autoFillOutputProduct: false,
  isTrigger: false,
  warehouseId: null,
  packagingTypeId: null,
  packagingQuantity: null,
  splitPaks: false,
  hasPallet: false,
  suppliers: {},
  automationBranching: null,
};

const initialState = {
  formControls: { ...defaultControls },
  invalidControls: { ...defaultInvalidInputs },
  formIsOpen: false,
  deleteIsOpen: false,
  toDeleteId: '',
  toEditId: '',
  edit: false,
  error: false,
  products: {},
  warehouses: {},
  packagingTypes: {},
  suppliers: {},
};

const processTypes = createReducer(initialState, {
  [DISABLE_ERRORS](state) {
    state.error = false;
  },
  [TOGGLE_FORM](state, action) {
    state[action.modal] = !state[action.modal];
    state.edit = false;
    state.formControls = { ...defaultControls };
    state.invalidControls = { ...defaultInvalidInputs };
  },
  [CHANGE_CONTROLS](state, action) {
    state.formControls = {
      ...state.formControls,
      ...action.controls,
    };
    state.invalidControls = {
      ...state.invalidControls,
      ...(action.invalidControls || {}),
    };
  },
  [TOGGLE_DELETE](state, action) {
    state.deleteIsOpen = !state.deleteIsOpen;
    state.toDeleteId = action.id;
  },
  [TOGGLE_EDIT_PROCESS_TYPE](state, action) {
    state.formIsOpen = true;
    state.toDeleteId = '';
    state.toEditId = action.item.id;
    state.formControls.name = action.item.name;
    state.formControls.allowMultipleLots = action.item.allowMultipleLots;
    state.formControls.allowMultipleFruits = action.item.allowMultipleFruits;
    state.formControls.loss = action.item.loss || 0;

    state.formControls.productId = action.item.productId || null;

    state.formControls.autoCreateInboundPak = action.item.autoCreateInboundPak || false;
    state.formControls.allowPakSubdivision = action.item.allowPakSubdivision || false;
    state.formControls.nextProcessTypeId = action.item.nextProcessTypeId || null;
    state.formControls.lowTimeThreshold = action.item.lowTimeThreshold || null;
    state.formControls.highTimeThreshold = action.item.highTimeThreshold || null;
    state.formControls.automationBranching = action.item.automationBranching || null;
    state.formControls.autoFillOutputProduct = action.item.autoFillOutputProduct || false;

    state.formControls.isTrigger = action.item.isTrigger || false;
    state.formControls.warehouseId = action.item.warehouseId || null;
    state.formControls.packagingTypeId = action.item.packagingTypeId || null;
    state.formControls.packagingQuantity = action.item.packagingQuantity || null;
    state.formControls.splitPaks = action.item.splitPaks || false;
    state.formControls.hasPallet = action.item.hasPallet || false;

    state.edit = true;
  },
  [SET_INVALID_CONTROLS](state, action) {
    state.invalidControls = {
      ...state.invalidControls,
      ...action.controls,
    };
  },
  [PROCESS_TYPES.CREATE_PROCESS_TYPE_SUCCESS](state) {
    state.formIsOpen = false;
    state.formControls = { ...defaultControls };
    state.invalidControls = { ...defaultInvalidInputs };
  },
  [PROCESS_TYPES.DELETE_PROCESS_TYPE_SUCCESS](state) {
    state.deleteIsOpen = false;
    state.toDeleteId = '';
  },
  [PROCESS_TYPES.EDIT_PROCESS_TYPE_SUCCESS](state) {
    state.formControls = { ...defaultControls };
    state.invalidControls = { ...defaultInvalidInputs };
    state.formIsOpen = false;
    state.toDeleteId = '';
    state.toEditId = '';
    state.edit = false;
  },
  [PROCESS_TYPES.UPDATE_LOSS_PERCENTAGE_SUCCESS]() { },
  [PROCESS_TYPES.UPDATE_LOSS_PERCENTAGE_FAIL](state) {
    state.error = true;
  },
  [PROCESS_TYPES.GET_STATE_FROM_API_SUCCESS](state, action) {
    state.objects = action.payload.objects || action.payload || {};
  },
  [PROCESS_TYPES.GET_OPERATIONAL_MASTERS_SUCCESS](state, action) {
    const data = action.payload || action;
    state.products = data.products || {};
    state.warehouses = data.warehouses || {};
    state.packagingTypes = data.packagingTypes || {};
    state.suppliers = data.suppliers || {};
  },
  [PROCESS_TYPES.CREATE_RECEIPT_TRIGGER_SUCCESS](state) {
    state.receiptsModalOpen = false;
    state.formControls = { ...defaultControls };
  },
  [PROCESS_TYPES.CREATE_DISPATCH_TRIGGER_SUCCESS]() {
  },
});

export default processTypes;
